import { FormInstance } from 'antd';
import { useMapSlice } from 'app/containers/Map/slice';
import { selectSelectedTempPolygonsIds } from 'app/containers/Map/slice/selectors';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFieldSlice } from '../../slice';
import { selectMappedTempFieldsList } from '../../slice/selectors';
import TempFieldsList from '../TempFieldsList/TempFieldsList';

interface IProps {
  formId: string;
  form: FormInstance;
}

const AddFieldsList: FC<IProps> = ({ formId, form }) => {
  const dispatch = useDispatch();

  const { actions: mapActions } = useMapSlice();
  const { actions } = useFieldSlice();

  const mappedTempFieldList = useSelector(selectMappedTempFieldsList);
  const selectedIds = useSelector(selectSelectedTempPolygonsIds);

  const onClick = useCallback(
    (id: string) => () => {
      dispatch(mapActions.toggleTempPolygon(id));
    },
    [dispatch, mapActions],
  );

  const onCheckAllFields = () => {
    dispatch(mapActions.toggleAllTempPolygon());
  };

  const onFocus = useCallback(
    (id: string) => () => {
      dispatch(mapActions.zoomOnTempPolygon(id));
    },
    [dispatch, mapActions],
  );

  const onSubmit = (values: { [key: string]: string }) => {
    dispatch(actions.submitNewFields(values));
  };

  return (
    <TempFieldsList
      form={form}
      formId={formId}
      fieldsArr={mappedTempFieldList}
      selectedIds={selectedIds}
      onListItemClick={onClick}
      onListItemInputFocus={onFocus}
      onSubmit={onSubmit}
      onCheckAllFields={onCheckAllFields}
    />
  );
};

export default AddFieldsList;
